const ROUTES = {
  HOME: "/",
  OURPLATFORM: "/platform",
  LEADERSHIP: "/leadership",
  TRYOUT: "/tryout",
  CONTACTUS: "/contact",
  CLASSREG: "/classregistration",
  CARDREG: "/cardregistration",
  CONTESTREG: "/contestregistration",
  PROFESSORREG: "/professorregister",
  TEACHERREG: "/teacherregister",
  PROFESSOR_PROFILE: "/professor-profile",
  CLASSLIST: "/classlist",
  CARDLIST: "/cardlist",
  CARDGRID: "/cardgrid",
  CONTESTLIST: "/contestlist",
  INVITED_CONTESTLIST: "/invited-contestlist",
  HOSTED_CONTESTLIST: "/hosted-contestlist",
  STUDENTREG: "/studentregistration",
  SUPERADMIN_REG: "/superadminregistration",
  STUDENT_PROFILE: "/student-profile",
  STUDENT_INVITATION: "/student-invitation",
  INVITE: "/invite",
  ADDCLASS: "/addClass",
  ADDCONTEST: "/addContest",
  DASHBOARD: "/dashboard",
  CONTEST_DASHBOARD: "/contest-dashboard",
  AUTOINVITE: "/invitebulk",
  QUIZ: "/quiz",
  PLAYERREG: "/playeregistration",
  PLAYER_PROFILE: "/player-profile",
  PLAYER_INVITATION: "/player-invitation",
  RESULT: "/result",
  TOPIC: "/topic",
  CONTEST_TOPIC: "/contest-topic",
  TOPICITEM: "/topicitem",
  CONTEST_TOPICITEM: "/contest-topicitem",
  SIGNUP: "/signup",
  EXAMPLE: "/example",
  EXAMPLE_REG: "/example-reg",
  DEMO_SIGN_IN_PROFESSOR: "/DemoSignInAsProfessor",
  DEMO_SIGN_IN_TEACHER: "/DemoSignInAsTeacher",
  DEMO_SIGN_IN_STUDENT: "/DemoSignInAsStudent",
  DEMO_SIGN_IN_PLAYER: "/DemoSignInAsPlayer",
  MY_GAMES:"/myGame",//for player only
  COLLABORATE: '/collaborate',

  //guide pages
  GUIDE_STUDENT: '/guide',
  GUIDE_PROFESSOR: '/guide',
  GUIDE_TEACHER: '/guide',
  GUIDE_PLAYER: '/guide',
};
export default ROUTES;
